import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
// import {
//   addArtisanPrivateInquiryAction,
//   editArtisanPrivateInquiryAction,
//   getArtisanPrivateInquiryAction,
// } from '../../../../modules/inquiries/artisans/private/Actions';

import {
  inquiryByIdSelector,
  artisanPrivateInquiriesIsLoadingSelector,
} from '../../../../../modules/myInquiries/Artisan/Private/Selectors';

// import { getArtisansAction } from '../../../../modules/artisans/Actions';
import {
  getMyArtisanPrivateInquiryAction,
  addProposalByArtisanAction,
} from '../../../../../modules/myInquiries/Artisan/Private/Actions';
// import { artisansAsLabelAndValueSelector } from '../../../../modules/artisans/Selectors';

import { getArtisanProductsAction } from '../../../../../modules/artisanProducts/Actions';
import {
  artisansProductsAsLabelAndValueSelector,
  artisanProductByIdSelector,
} from '../../../../../modules/artisanProducts/Selectors';

import {
  InputField,
  TextArea,
  Select,
  FormSectionTitle,
  Upload,
} from '../../../../../components/form/';

import FormGroup from '../../../../../components/form/FormGroup';
import { artisanDataSelector } from '../../../../../modules/auth/Selectors';
import getLangData from '../../../../../utils/getLangData';

const ViewPrivateInquiry = (props) => {
  const {
    isLoading,
    pendingIsLoading,

    inquiryID,
    addProposal,
    inquiry,
    getPrivateInquiry,
    moderateCreateArtisanPrivateInquiry,
    getArtisans,
    artisanSingleProduct,
    getArtisanProducts,
    artisanProducts,
    artisan,
    addPrivateIquiry,
    editPrivateInquiry,
    artisanData,
  } = props;

  const [mode, setMode] = useState('');

  // for testing only
  const artisanId = artisanData._id;
  const { trusted } = artisanData

  useEffect(() => {
    getArtisanProducts();
    getPrivateInquiry(inquiryID);
    console.log(inquiry);
    if (inquiry?.proposal?.message) {
      setMode('edit');
    } else {
      setMode('create');
    }
  }, [inquiryID, getPrivateInquiry]);

  console.log(mode);
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...inquiry }}
      onSubmit={(values) => {
        const body = {
          price: values.proposal.price,
          message: values.proposal.message,
          customerId: values.customerId,
          inquiryId: values._id,
          artisanId: values.artisanId,
          attachment: values.proposal.attachment,
        };
        addProposal(body, trusted);
      }}
    >
      {({ values, handleSubmit, setFieldValue }) => {
        return (
          <FormGroup
            handleSubmit={handleSubmit}
            heading={getLangData().general_words.view_private_inquiry}
            isLoading={isLoading || pendingIsLoading}
          >
            <InputField
              name="customerProfileDetail.businessName"
              label={getLangData().fields.name}
              disabled
            />

            {/* <InputField name='artisanDetail.businessName' label='Artisan Name' /> */}

            {/* <InputField name='aproductId.name' label='Product Name' /> */}
            <InputField name="artisanProduct.name" label={getLangData().fields.product_name} disabled />
            {/* {console.log(values.aproductId)} */}

            <TextArea name="message" label={getLangData().fields.message} disabled />
            <InputField name="qtyRequired" label={getLangData().fields.quantity} disabled />
            <Upload
              disabled={true}
              data={{ userID: artisanId }}
              name="attachment"
              label={`${getLangData().fields.inquiry_image} : `}
              S3Bucket="warshatna-users"
              // API="customer/customer-category-image-signedurl/"
              API="users/user-profile-image-signedurl"
            />

            <FormSectionTitle>{getLangData().fields.proposal}</FormSectionTitle>
            <InputField name="proposal.price" label={getLangData().fields.price} type="number" />
            <TextArea name="proposal.message" label={getLangData().fields.message} />
            <Upload
              data={{ userID: artisanId }}
              name="proposal.attachment"
              label={getLangData().fields.image}
              S3Bucket="warshatna-users"
              // API="customer/customer-category-image-signedurl/"
              API="users/user-profile-image-signedurl"
            />
          </FormGroup>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: inquiryByIdSelector(state, inquiryID),
    isLoading: artisanPrivateInquiriesIsLoadingSelector(state),
    // artisan: artisansAsLabelAndValueSelector(state),
    // artisanProducts: artisansProductsAsLabelAndValueSelector(state),
    artisanSingleProduct: artisanProductByIdSelector(state, props.id),
    artisanData: artisanDataSelector(state),
  };
};

const mapDispatchToProps = {
  getPrivateInquiry: getMyArtisanPrivateInquiryAction,
  addProposal: addProposalByArtisanAction,
  // getArtisans: getArtisansAction,
  getArtisanProducts: getArtisanProductsAction,
  // editPrivateInquiry: editArtisanPrivateInquiryAction,
  // addPrivateIquiry: addArtisanPrivateInquiryAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPrivateInquiry);
